import styles from './index.module.sass';

export const ProfitBadge = ({ profit, short }: IProfitBadge) => {
  return (
    <div
      className={styles.root}
      style={{
        background:
          profit > 0 ? 'linear-gradient(90deg, #66B28A, #007E3C)' : profit < 0 ? 'linear-gradient(90deg, #E73A42, #871E23)' : '#AAB3CB',
      }}
    >
      <span className={styles.label}>
        {short ? (profit > 0 ? 'выгода:' : 'убыток:') : (profit > 0 ? 'выгода от миксования:' : 'убыток от миксования:')}
      </span>{' '}
      <span className={styles.value}>
        {profit > 0
          ? `+ ${profit?.toLocaleString('RU-ru')} ₽`
          :  profit < 0 ? `${profit?.toLocaleString('RU-ru')} ₽` : "цена микса не определена" }
        
      </span>
    </div>
  );
};

interface IProfitBadge {
  profit: number;
  short?: true;
}
